// extracted by mini-css-extract-plugin
export default {"section":"StatisticsReport_section__HNpEx","sectionHead":"StatisticsReport_sectionHead__RK6bP","unavailable":"StatisticsReport_unavailable__2hzaY"};